import {
  simpleActionErrorMsg,
  simpleActionSuccessMsg
} from '~commonInfra/contentActions/ActionHelpers';
import { ContentActionNotification } from '~commonInfra/contentActions/ContentActionNotification';
import { openReactConfirmationDialog } from '~commonInfra/dialogs/ReactConfirmationDialog';
import { TabDialogWidth } from '~commonInfra/dialogs/style/TabDialogWidth';
import { Set } from '~commonInfra/utils/Set';

import { Messages } from '../../codegen/Localize';
import { L10n } from '../../commonInfra/L10n/L10n';
import { OAuthCredentials } from '../../connectivity/resources/OAuthCredentials';
import { IOAuthCredential } from '../../connectivity/serverApi/types/OAuth/IOAuthCredential';
import { OAuthCredentialsService } from '../../connectivity/services/OAuthCredentialsService';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { CredentialTypeFilter } from '../../userSettings/services/filters/CredentialTypeFilter';

export function showDeleteOAuthCredentialsDialog(oAuthCredentialsInput: Set<IOAuthCredential>): Promise<any>  {
 let credType: string = oAuthCredentialsInput.size() === 1 ?
  (oAuthCredentialsInput.first().keypairAuthServer ? Messages.addNewCredential_KeyPairAuth() : Messages.addNewCredential_OAuth()) : '';
 let body: string = oAuthCredentialsInput.size() === 1?
 Messages.confirmDeleteCredential({
    USERNAME: L10n.elideIfLong(oAuthCredentialsInput.first().username),
    CRED_TYPE: credType,
    TRANSLATED_TYPE: CredentialTypeFilter.filter(
      OAuthCredentialsService.getTypeInfo(oAuthCredentialsInput.first().type))
  }) : Messages.confirmDeleteOAuthCredentials({ CREDENTIAL_COUNT_LOC: L10n.localizedCount(oAuthCredentialsInput.size())});

const dialogInstance = openReactConfirmationDialog<string[], IResult>({
    title: Messages.deleteMessage(),
    message: body,
    actionName: Messages.confirmDeleteButton({
      ITEM_COUNT: oAuthCredentialsInput.size(),
      ITEM_COUNT_LOC: L10n.localizedCount(oAuthCredentialsInput.size())
    }),
    isActionDelete: true,
    paramsForAction: oAuthCredentialsInput.keys(),
    action: () => OAuthCredentials.del(oAuthCredentialsInput.keys()),
    dialogWidth: TabDialogWidth.width375px
  });

  dialogInstance.result.then((result: IResult) => {
    ContentActionNotification.displaySingleToastForResult({
      items: oAuthCredentialsInput,
      errors: result.errors,
      successMsg: simpleActionSuccessMsg(Messages.deleteOAuthCredentialsSuccess),
      errorMsg: simpleActionErrorMsg(Messages.deleteOAuthCredentialsError),
    });
  });

  return Promise.resolve(dialogInstance.result);

}
